import {FirebaseTopicModel} from "../../firebase-topic-model";
import {IUserTicket, UserTicketsUpdateData} from "./user-tickets-update-topic.model.interface";

export  class UserTicketsUpdateTopicModel extends FirebaseTopicModel<UserTicketsUpdateData, IUserTicket[]> {
    getTopicName(): string {
        //TODO - we need to see what exactly the topic name is
        return `inGameTicketUpdate/${this.services.user.cid}`
    }
    getTopicLabel(): string {
        return "InGameTicketsUpdate";
    }
    protected _mapRawMessageToPublishMessage(rawMessage: UserTicketsUpdateData): IUserTicket[] {
        return rawMessage?.tickets ?? [];
    }

    //TODO - remove this method when you start using this topic
    protected async _isEnabled(): Promise<boolean> {
        return false;
    }

}